import classNames from 'classnames';
import { memo } from 'react';

import useStyles from './styles';
import { IImageSectionColumnsInfo } from './types';

function ImageSectionColumnsInfo({ columns, titleElement = 'h3' }: IImageSectionColumnsInfo) {
  const classes = useStyles();
  const Tag = titleElement;

  return (
    <div className={classNames(classes.root, classes.mobile)}>
      {columns.map(({ title, description }) => (
        <div key={title} className={classes.item}>
          <div className={classes.itemContainer}>
            <Tag className={classes.itemTitle}>{title}</Tag>
            <p className={classes.itemDescription}>{description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default memo(ImageSectionColumnsInfo);
